export default __webpack_public_path__ + "static/media/CheckIn.a3c5d395.svg";